import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20and%20elegant%20abstract%20background%20with%20golden%20and%20red%20gradient%20tones%2C%20minimalist%20geometric%20shapes%2C%20soft%20lighting%2C%20luxurious%20feel%2C%20professional%20website%20hero%20background%2C%20no%20text%20no%20people&width=1600&height=900&seq=home-hero&orientation=landscape"
        alt="注册送彩金优惠活动"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-300/30 text-accent-100 text-xs md:text-sm mb-5">
          <i className="ri-sparkling-line"></i>
          新用户专属福利
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-background-50 text-center max-w-3xl leading-tight">
          注册送彩金，零门槛开启
          <span className="text-accent-300">娱乐体验</span>
        </h1>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-background-200/90 text-center max-w-xl leading-relaxed">
          汇集最新注册送彩金活动信息，提供专业领取攻略与提款指南，助你轻松享受每一份免费福利
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/latest-promotions"
            className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看最新优惠
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/newbie-tutorial"
            className="px-6 py-3 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium text-sm md:text-base hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
          >
            新手入门指南
          </Link>
        </div>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { value: '200+', label: '合作平台' },
            { value: '50万+', label: '服务用户' },
            { value: '99.7%', label: '好评率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-300">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-200/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}